<script>
  import DisclosureStepper from '../components/DisclosureStepper.svelte';
  import AggregateBuilder from '../components/AggregateBuilder.svelte';
  import Button from '../components/Button.svelte';
  import Alert from '../components/Alert.svelte';
  import HelpDrawer from '../components/HelpDrawer.svelte';
  import { disclosureDraft, ensureDraft } from '../lib/disclosureDraft.svelte.js';
  import { nav } from '../lib/nav.svelte.js';
  import { onMount } from 'svelte';
  import { aggregatesGate } from '../../../lib/disclosure_core.js';
  import { HELP } from '../lib/help.js';

  // The same gate the stepper uses, so the two agree by construction: everything
  // it asks about is what the Pod would reject on save.
  const gate = $derived(aggregatesGate(disclosureDraft));
  onMount(() => ensureDraft(nav.params.source));
</script>

<DisclosureStepper active={1} />
<HelpDrawer {...HELP['disclosure/aggregates']} />
<h1 class="wf2-title wf2-title-level-1">Build cubes</h1>
{#if disclosureDraft.loaded}<p class="wf2-caption">Active source: <strong>{disclosureDraft.connector?.sourceLabel ?? disclosureDraft.sourceId}</strong> <span class="mono">{disclosureDraft.sourceId}</span></p>{/if}
<p class="wf2-subtitle">A cube is a table of counts — how many people fall into each group, and nothing about any one person. Choose the counts you want. Small groups are hidden before anything can be published.</p>

{#if !disclosureDraft.mapping}
  <Alert title="Choose a source first"><Button to="disclosure">Open sources</Button></Alert>
{:else}
  <AggregateBuilder mapping={disclosureDraft.mapping} aggregateMapping={disclosureDraft.aggregateMapping}
    sourceId={disclosureDraft.sourceId} aggregations={disclosureDraft.aggregations} rows={disclosureDraft.rows} />
  <div class="wf2-row" style="gap:12px">
    <Button variant="primary" to={`disclosure/confirm?source=${encodeURIComponent(disclosureDraft.sourceId)}`} disabled={gate.blocked}>Next: confirm</Button>
    <Button to={`disclosure/label?source=${encodeURIComponent(disclosureDraft.sourceId)}`}>Back</Button>
  </div>
  {#if gate.blocked}<p class="wf2-hint">{gate.reason}</p>{/if}
{/if}
